import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "",
    name: "admin-model-edit",
    component: () => import("@/admin/pages/models/[id]/edit/index.vue"),
    meta: {
      title: "admin.models.edit.index",
      customTitle: true,
      needsAuthentication: true,
      nav: "editTabs",
      activeRoute: "admin-models",
    },
  },
  {
    path: "metrics/",
    name: "admin-model-edit-metrics",
    component: () => import("@/admin/pages/models/[id]/edit/metrics.vue"),
    meta: {
      title: "admin.models.edit.metrics",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "cargo-and-fuel/",
    name: "admin-model-edit-cargo-and-fuel",
    component: () =>
      import("@/admin/pages/models/[id]/edit/cargo-and-fuel.vue"),
    meta: {
      title: "admin.models.edit.cargoAndFuel",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "cargo-holds/",
    name: "admin-model-edit-cargo-holds",
    component: () => import("@/admin/pages/models/[id]/edit/cargo-holds.vue"),
    meta: {
      title: "admin.models.edit.cargoHolds",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "prices/",
    name: "admin-model-edit-prices",
    component: () => import("@/admin/pages/models/[id]/edit/prices.vue"),
    meta: {
      title: "admin.models.edit.prices",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "fleetchart/",
    name: "admin-model-edit-fleetchart",
    component: () => import("@/admin/pages/models/[id]/edit/fleetchart.vue"),
    meta: {
      title: "admin.models.edit.fleetchart",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "images/",
    name: "admin-model-edit-images",
    component: () => import("@/admin/pages/models/[id]/edit/images.vue"),
    meta: {
      title: "admin.models.edit.images",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "videos/",
    name: "admin-model-edit-videos",
    component: () => import("@/admin/pages/models/[id]/edit/videos.vue"),
    meta: {
      title: "admin.models.edit.videos",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "hardpoints/",
    name: "admin-model-edit-hardpoints",
    component: () => import("@/admin/pages/models/[id]/edit/hardpoints.vue"),
    meta: {
      title: "admin.models.edit.hardpoints",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "positions/",
    name: "admin-model-edit-positions",
    component: () => import("@/admin/pages/models/[id]/edit/positions.vue"),
    meta: {
      title: "admin.models.edit.positions",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "loaners/",
    name: "admin-model-edit-loaners",
    component: () => import("@/admin/pages/models/[id]/edit/loaners.vue"),
    meta: {
      title: "admin.models.edit.loaners",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "snub-crafts/",
    name: "admin-model-edit-snub-crafts",
    component: () => import("@/admin/pages/models/[id]/edit/snub-crafts.vue"),
    meta: {
      title: "admin.models.edit.snubCrafts",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "docks/",
    name: "admin-model-edit-docks",
    component: () => import("@/admin/pages/models/[id]/edit/docks.vue"),
    meta: {
      title: "admin.models.edit.docks",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "paints/",
    name: "admin-model-edit-paints",
    component: () => import("@/admin/pages/models/[id]/edit/paints.vue"),
    meta: {
      title: "admin.models.edit.paints",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "modules/",
    name: "admin-model-edit-modules",
    component: () => import("@/admin/pages/models/[id]/edit/modules.vue"),
    meta: {
      title: "admin.models.edit.modules",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "upgrades/",
    name: "admin-model-edit-upgrades",
    component: () => import("@/admin/pages/models/[id]/edit/upgrades.vue"),
    meta: {
      title: "admin.models.edit.upgrades",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "packages/",
    name: "admin-model-edit-packages",
    component: () => import("@/admin/pages/models/[id]/edit/packages.vue"),
    meta: {
      title: "admin.models.edit.packages",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
  {
    path: "history/",
    name: "admin-model-edit-history",
    component: () => import("@/admin/pages/models/[id]/edit/history.vue"),
    meta: {
      title: "admin.models.edit.history",
      customTitle: true,
      activeRoute: "admin-models",
      nav: "editTabs",
      needsAuthentication: true,
    },
  },
];
